<app-overlay-spinner *ngIf="isLoading"></app-overlay-spinner>
<h1 mat-dialog-title>{{ 'TRIPS.LOADING' | translate }}</h1>